import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {RxReactiveFormsModule} from '@rxweb/reactive-form-validators';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {FileUploadModule} from 'primeng/fileupload';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {ProgressBarModule} from 'primeng/progressbar';
import {SupportRequestFormComponent} from './support-request-form.component';

@NgModule({imports: [CommonModule, ReactiveFormsModule, TranslateModule, RxReactiveFormsModule, ButtonModule, DropdownModule, FileUploadModule, InputTextModule, InputTextareaModule, ProgressBarModule], declarations: [SupportRequestFormComponent], exports: [SupportRequestFormComponent]})
export class SupportRequestModule {}
